<template>
  <div>
    <topo></topo>
    <b-container id="corpo-site-pdf">
      <router-view></router-view>
    </b-container>
  </div>
</template>

<script>
  import topo from '@/components/layout/pdf/topo.vue'
  export default {
    name: 'LayoutPdf',
    components: {
      topo
    }
  }
</script>

<style lang="scss">
  #corpo-site-pdf {
    margin-top: 122px;
    min-height: 385px;
    .tituloPaginaRow {
      padding-left: 25px;
      padding-right: 25px;
      background-repeat: repeat-x;
    }
    .tituloPagina {
      padding-left: 10px;
      padding-right: 10px;
      margin-bottom: 15px;
      font-size: 20px;
      font-weight: bold;
      font-style: italic;
      background: white;
    }
    p {
      font-size: 15px;
      font-weight: 400;
      font-style: italic;
    }
  }
  @media (min-width: 1200px) {
    #corpo-site-pdf {
      max-width: calc(100% - 30px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/LayoutPdf.vue